<template>
	<div class="filters-box-row">
		<div class="filters-container">
			<div class="input-box">
				<span>线路编号：</span>
				<el-input
					v-model="linecode"
					placeholder="请输入线路编号"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
			<div class="input-box">
				<span>线路名称：</span>
				<el-input
					v-model="linename"
					placeholder="请输入线路名称"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
			<div class="input-box">
				<span>车牌号：</span>
				<el-input
					v-model="platenumber"
					placeholder="请输入车牌号"
					class="name-input"
					size="mini"
					@keyup.enter.native="onSearch"
					></el-input>
			</div>
            <el-button
				type="primary"
				class="btn fx-btn"
				size="small"
				@click="onSearch">查询</el-button>
			<el-button
				class="btn fx-btn"
				size="small"
                plain
				@click="clearing">清空</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Search',
	props: {
		orderKey: Number,
		time: Array
	},
	data () {
		return {
			linecode: '',
			linename: '',
			platenumber: ''
		}
	},
	methods: {
		clearing () {
			this.linecode = ''
			this.linename = ''
			this.platenumber = ''
			this.onSearch()
		},
		onSearch () {
			let params = {
				linecode: this.linecode,
				linename: this.linename,
				platenumber: this.platenumber,
				page: 1,
				size: 20
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/line/list`,
				data: params
			}).then(res => {
				var data = {
					list: res.recordList,
					count: res.recordCount
				}
				this.$emit('getTableData', data)
				this.$emit('getParamsData', params)
			}).catch(() => {
				this.$emit('getParamsData', params)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	display: flex;
	flex-direction column
	padding: 10px 0;
	width :100%;
	line-height :60px;
	min-width :600px;
	border-bottom 1px solid #dce2fd;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		height: 60px
		.input-box {
			display flex
			width: 250px
			margin-left: 20px
			span {
				margin-right: 10px
			}
			.name-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
}
</style>
